import React from "react";

const Technologies = () => {
  return (
    <section className="techno-container" id="technologies">
      <h1>Technologies</h1>
      <div className="tech-box">
        <div className="tech">Javascript</div>
        <div className="tech">React</div>
        <div className="tech">Python</div>
        <div className="tech">HTML/CSS</div>
        <div className="tech">MongoDb</div>
        <div className="tech">MySql</div>
        <div className="tech">Flask</div>
        <div className="tech">Node.js</div>
        <div className="tech">Express.js</div>
        <div className="tech">Bootstrap</div>
        <div className="tech">Axios</div>
        <div className="tech">Mapbox</div>
        <div className="tech">Ajax</div>
        <div className="tech">RESTful Api</div>
        <div className="tech">Git</div>
        <div className="tech">Github</div>
        <div className="tech">Postman</div>
      </div>
    </section>
  );
};

export default Technologies;
